/**
 * shoud consistent with backend
 */
export const countryCodeEnum = {
  AFGHANISTAN: 3340,
  ALAND_ISLANDS: 7048,
  ALBANIA: 3276,
  ALGERIA: 3290,
  AMERICAN_SAMOA: 7027,
  ANDORRA: 3481,
  ANGOLA: 3490,
  ANGUILLA: 7049,
  ANTARCTICA: 5748,
  ANTIGUA_AND_BARBUDA: 7047,
  ARGENTINA: 3346,
  ARMENIA: 6729,
  ARUBA: 7050,
  AUSTRALIA: 3512,
  AUSTRIA: 3554,
  AZERBAIJAN: 3399,
  BAHAMAS: 3588,
  BAHRAIN: 3624,
  BANGLADESH: 7028,
  BARBADOS: 7046,
  BELARUS: 3665,
  BELGIUM: 3701,
  BELIZE: 3809,
  BENIN: 3686,
  BERMUDA: 3673,
  BHUTAN: 3817,
  BOLIVIA: 3781,
  BOSNIA_AND_HERZEGOVINA: 3795,
  BOTSWANA: 3808,
  BOUVET_ISLAND: 7051,
  BRAZIL: 3636,
  BRITISH_INDIAN_OCEAN: 7052,
  BRUNEI_DARUSSALAM: 6458,
  BULGARIA: 3674,
  BURKINA_FASO: 3818,
  BURUNDI: 3865,
  CAMBODIA: 4635,
  CAMEROON: 4688,
  CANADA: 4575,
  CAPE_VERDE: 4160,
  CAYMAN_ISLANDS: 4711,
  CENTRAL_AFRICAN: 7025,
  CHAD: 7008,
  CHILE: 7010,
  CHINA: 1,
  CHRISTMAS_ISLAND: 7055,
  COCOS_ISLANDS: 7056,
  COLOMBIA: 4186,
  COMOROS: 4713,
  CONGO_DEMOCRATIC: 7030,
  CONGO_REPUBLIC: 7031,
  COOK_ISLANDS: 4809,
  COSTA_RICA: 4221,
  COTE_D_IVOIRE: 7045,
  CROATIA: 7057,
  CUBA: 4233,
  CYPRUS: 6016,
  CZECH_REPUBLIC: 4661,
  DENMARK: 3899,
  DJIBOUTI: 4540,
  DOMINICA: 3981,
  DOMINICAN_REPUBLIC: 3982,
  ECUADOR: 4070,
  EGYPT: 3416,
  EL_SALVADOR: 5961,
  EQUATORIAL_GUINEA: 7032,
  ERITREA: 4093,
  ESTONIA: 3464,
  ETHIOPIA: 3423,
  FALKLAND_ISLANDS: 7058,
  FAROE_ISLAND: 4126,
  FIJI: 4137,
  FINLAND: 4138,
  FRANCE: 4101,
  FRENCH_GUIANA: 7059,
  FRENCH_POLYNESIA: 4127,
  FRENCH_SOUTHERN_TERR: 7060,
  GABON: 4624,
  GAMBIA: 4183,
  GEORGIA: 5859,
  GERMANY: 3915,
  GHANA: 4611,
  GIBRALTAR: 7061,
  GREECE: 6633,
  GREENLAND: 4232,
  GRENADA: 4231,
  GUADELOUPE: 7062,
  GUAM: 4253,
  GUATEMALA: 6404,
  GUERNSEY: 7063,
  GUINEA: 4564,
  GUINEA_BISSAU: 4574,
  GUYANA: 4254,
  HAITI: 4305,
  HEARD_MCDONALD_ISLANDS: 7064,
  HONDURAS: 4514,
  HONG_KONG: 7033,
  HUNGARY: 6673,
  ICELAND: 3714,
  INDIA: 6845,
  INDONESIA: 6877,
  IRAN: 6766,
  IRAQ: 6765,
  IRELAND: 3436,
  ISLE_OF_MAN: 7065,
  ISRAEL: 6767,
  ITALY: 6777,
  JAMAICA: 6713,
  JAPAN: 5860,
  JERSEY: 7066,
  JORDAN: 6976,
  KAZAKHSTAN: 4266,
  KENYA: 4759,
  KIRIBATI: 4535,
  KOREA: 7041,
  KOSOVO: 7034,
  KUWAIT: 4735,
  KYRGYZSTAN: 4546,
  LAOS: 4850,
  LATVIA: 4810,
  LEBANON: 4869,
  LESOTHO: 4838,
  LIBERIA: 4877,
  LIBYA: 4896,
  LIECHTENSTEIN: 4910,
  LITHUANIA: 4897,
  LUXEMBOURG: 4912,
  MACAO: 7069,
  MACEDONIA: 5155,
  MADAGASCAR: 4978,
  MALAWI: 5010,
  MALAYSIA: 5015,
  MALDIVES: 4986,
  MALI: 5144,
  MALTA: 5009,
  MARSHALL_ISLANDS: 5156,
  MARTINIQUE: 7070,
  MAURITANIA: 5161,
  MAURITIUS: 5160,
  MAYOTTE: 7071,
  MEXICO: 5619,
  MICRONESIA: 5557,
  MOLDOVA: 5605,
  MONACO: 5617,
  MONGOLIA: 5527,
  MONTENEGRO: 7035,
  MONTSERRAT: 7073,
  MOROCCO: 5606,
  MOZAMBIQUE: 5618,
  MYANMAR: 5589,
  NAMIBIA: 5681,
  NAURU: 5750,
  NEPAL: 5751,
  NETHERLANDS: 4482,
  NETHERLANDS_ANTILLES: 7074,
  NEW_CALEDONIA: 7075,
  NEW_ZEALAND: 6647,
  NICARAGUA: 5767,
  NIGER: 5786,
  NIGERIA: 5796,
  NIUE: 7076,
  NORFOLK_ISLAND: 7077,
  NORTH_KOREA: 7036,
  NORTH_MARIANA: 3685,
  NORWAY: 5804,
  OMAN: 3389,
  PAKISTAN: 3589,
  PALAU: 5826,
  PALESTINIAN: 7037,
  PANAMA: 3635,
  PAPUA_NEW_GUINEA: 3567,
  PARAGUAY: 3600,
  PERU: 5558,
  PHILIPPINES: 4131,
  PITCAIRN: 7079,
  POLAND: 3716,
  PORTUGAL: 5828,
  PUERTO_RICO: 3715,
  QATAR: 4700,
  REUNION: 7080,
  ROMANIA: 4935,
  RUSSIA: 3983,
  RWANDA: 4917,
  SAINT_BARTHELEMY: 7081,
  SAINT_LUCIA: 6053,
  SAINT_MARTIN: 7083,
  SAINT_VINCENT_AND_THE_GRENADINES: 6056,
  SAMOA: 5511,
  SAN_MARINO: 6054,
  SAO_TOME_PRINCIPE: 6050,
  SAUDI_ARABIA: 6025,
  SENEGAL: 6003,
  SERBIA: 5987,
  SEYCHELLES: 6024,
  SIERRA_LEONE: 5997,
  SINGAPORE: 6645,
  SINT_MAARTEN: 7040,
  SLOVAKIA: 6084,
  SLOVENIA: 6094,
  SOLOMON_ISLANDS: 6133,
  SOMALIA: 6145,
  SOUTH_AFRICA: 5696,
  SOUTH_GEORGIA: 7085,
  SOUTH_KOREA: 7041,
  SOUTH_SUDAN: 7042,
  SPAIN: 6581,
  SRI_LANKA: 6057,
  ST_HELENA: 7082,
  ST_KITTS_NEVIS: 7039,
  ST_PIERRE_MIQUELON: 7084,
  SUDAN: 6110,
  SURINAME: 6121,
  SVALBARD: 7087,
  SWAZILAND: 6109,
  SWEDEN: 5909,
  SWITZERLAND: 5932,
  SYRIA: 6695,
  TAIWAN: 7043,
  TAJIKISTAN: 6146,
  TANZANIA: 7089,
  THAILAND: 6163,
  TIMOR_LESTE: 3959,
  TOGO: 3974,
  TOKELAU: 7091,
  TONGA: 6268,
  TRINIDAD_AND_TOBAGO: 6277,
  TUNISIA: 6278,
  TURKEY: 6305,
  TURKMENISTAN: 6385,
  TURKS_AND_CAICOS_ISLANDS: 7092,
  TUVALU: 6304,
  UGANDA: 6459,
  UKRAINE: 6517,
  UNITED_ARAB_EMIRATES: 3382,
  UNITED_KINGDOM: 6907,
  UNITED_STATES: 5176,
  URUGUAY: 6544,
  UZBEKISTAN: 6565,
  VANUATU: 6396,
  VATICAN_CITY_STATE: 7044,
  VENEZUELA: 6432,
  VIETNAM: 6991,
  VIRGIN_ISLANDS: 6431,
  VIRGIN_ISLANDS_US: 6430,
  WALLIS_FUTUNA: 7095,
  WESTERN_SAHARA: 7096,
  YEMEN: 6742,
  ZAMBIA: 6996,
  ZIMBABWE: 4676,
}

export const emeaCountryCodes = [
  7048, 3276, 3481, 7047, 3346, 6729, 7050, 3554, 3399, 3588, 7046, 3701, 3809, 3781, 3636, 3674, 4575, 4711, 7010,
  4186, 4221, 7057, 4233, 4661, 3899, 3981, 3982, 4070, 5961, 3464, 4126, 4138, 4101, 7059, 4127, 7060, 5859, 3915,
  7061, 6633, 4232, 4231, 7062, 6404, 7063, 4254, 4305, 4514, 6673, 3714, 3436, 7065, 6767, 6777, 6713, 7066, 7034,
  4810, 4910, 4897, 4912, 5155, 5009, 5156, 7070, 7071, 5619, 5605, 5617, 7035, 7073, 5606, 4482, 7074, 7075, 5767,
  5804, 3635, 3600, 5558, 3716, 5828, 3715, 7080, 4935, 7081, 7082, 7039, 6053, 7083, 7084, 6056, 6054, 5987, 7040,
  6084, 6094, 6581, 6121, 7087, 5909, 5932, 6277, 7092, 6907, 6544, 7044, 7095,
]

// used by telegram register form
export const countryList = {
  'United Kingdom': 'GB',
  France: 'FR',
  Germany: 'DE',
  Italy: 'IT',
  Poland: 'PL',
  Malaysia: 'MY',
  Afghanistan: 'AFG',
  'Aland Islands': 'AX',
  Albania: 'AL',
  Algeria: 'DZ',
  'American Samoa': 'AS',
  Andorra: 'AD',
  Angola: 'AO',
  Anguilla: 'AI',
  Antarctica: 'AQ',
  'Antigua and Barbuda': 'AG',
  Argentina: 'AR',
  Armenia: 'AM',
  Aruba: 'AW',
  Austria: 'AT',
  Azerbaijan: 'AZ',
  Bahamas: 'BS',
  Bahrain: 'BH',
  Bangladesh: 'BD',
  Barbados: 'BB',
  Belgium: 'BE',
  Belize: 'BZ',
  Benin: 'BJ',
  Bhutan: 'BT',
  Bolivia: 'BO',
  Botswana: 'BW',
  'Bouvet Island': 'BV',
  Brazil: 'BR',
  'British Indian Ocean Territory': 'IO',
  'Brunei Darussalam': 'BN',
  Bulgaria: 'BG',
  'Burkina Faso': 'BF',
  Cambodia: 'KH',
  Cameroon: 'CM',
  Canada: 'CA',
  'Cape Verde': 'CV',
  'Cayman Islands': 'KY',
  Chad: 'TD',
  Chile: 'CL',
  China: 'CN',
  'Christmas Island': 'CX',
  'Cocos (Keeling) Islands': 'CC',
  Colombia: 'CO',
  Comoros: 'KM',
  'Cook Islands': 'CK',
  'Costa Rica': 'CR',
  Croatia: 'HR',
  Cuba: 'CU',
  'Czech Republic': 'CZ',
  "Côte d'Ivoire": 'CI',
  Denmark: 'DK',
  Djibouti: 'DJ',
  Dominica: 'DM',
  'Dominican Republic': 'DO',
  Ecuador: 'EC',
  Egypt: 'EG',
  'El Salvador': 'SV',
  'Equatorial Guinea': 'GQ',
  Eritrea: 'ER',
  Estonia: 'EE',
  Eswatini: 'SZ',
  Ethiopia: 'ET',
  'Falkland Islands (Malvinas)': 'FK',
  'Faroe Islands': 'FO',
  'Federated States Of Micronesia Micronesia': 'FM',
  Fiji: 'FJ',
  Finland: 'FI',
  'French Guiana': 'GF',
  'French Polynesia': 'PF',
  'French Southern Territories': 'TF',
  Gabon: 'GA',
  Gambia: 'GM',
  Georgia: 'GE',
  Ghana: 'GH',
  Gibraltar: 'GI',
  Greece: 'GR',
  Greenland: 'GL',
  Grenada: 'GD',
  Guadeloupe: 'GP',
  Guatemala: 'GT',
  Guernsey: 'GG',
  Guinea: 'GN',
  Guyana: 'GY',
  Haiti: 'HT',
  'Heard Island And Mcdonald Islands': 'HM',
  Honduras: 'HN',
  HongKong: 'HK',
  Hungary: 'HU',
  Iceland: 'IS',
  India: 'IN',
  Indonesia: 'ID',
  Iran: 'IRN',
  Iraq: 'IQ',
  Ireland: 'IE',
  'Isle Of Man': 'IM',
  Israel: 'IL',
  Jamaica: 'JM',
  Japan: 'JP',
  Jersey: 'JE',
  Jordan: 'JO',
  Kazakhstan: 'KZ',
  Kenya: 'KE',
  Kiribati: 'KI',
  'Korea, Republic Of': 'KR',
  Kosovo: 'XK',
  Kuwait: 'KW',
  Kyrgyzstan: 'KG',
  Laos: 'LA',
  Latvia: 'LV',
  Lebanon: 'LB',
  Lesotho: 'LS',
  Liberia: 'LR',
  Libya: 'LY',
  Liechtenstein: 'LI',
  Lithuania: 'LT',
  Luxembourg: 'LU',
  Macao: 'MO',
  Macedonia: 'MK',
  Madagascar: 'MG',
  Malawi: 'MW',
  Maldives: 'MV',
  Mali: 'ML',
  Malta: 'MT',
  'Marshall Islands': 'MH',
  Martinique: 'MQ',
  Mauritania: 'MR',
  Mauritius: 'MU',
  Mayotte: 'YT',
  Mexico: 'MX',
  Moldova: 'MD',
  Monaco: 'MC',
  Mongolia: 'MN',
  Montserrat: 'MS',
  Morocco: 'MA',
  Mozambique: 'MZ',
  Myanmar: 'MM',
  Namibia: 'NA',
  Nauru: 'NR',
  Nepal: 'NP',
  Netherlands: 'NL',
  'New Caledonia': 'NC',
  'New Zealand': 'NZ',
  Nicaragua: 'NI',
  Niger: 'NE',
  Nigeria: 'NG',
  Niue: 'NU',
  'Norfolk Island': 'NF',
  'Northern Mariana Islands': 'MP',
  Norway: 'NO',
  Oman: 'OM',
  Pakistan: 'PK',
  Palau: 'PW',
  'Palestinian Territory, Occupied': 'PS',
  Panama: 'PA',
  'Papua New Guinea': 'PG',
  Paraguay: 'PY',
  Peru: 'PE',
  Philippines: 'PH',
  Pitcairn: 'PN',
  Portugal: 'PT',
  'Puerto Rico': 'PR',
  Qatar: 'QA',
  Reunion: 'RE',
  Romania: 'RO',
  Rwanda: 'RW',
  'Saint Barthelemy': 'GP',
  'Saint Helena': 'SH',
  'Saint Kitts and Nevis': 'KN',
  'Saint Lucia': 'LC',
  'Saint Martin': 'GP',
  'Saint Pierre And Miquelon': 'PM',
  'Saint Vincent and the Grenadines': 'VC',
  Samoa: 'WS',
  'San Marino': 'SM',
  'Sao Tome and Principe': 'ST',
  'Saudi Arabia': 'SA',
  Senegal: 'SN',
  Serbia: 'RS',
  Seychelles: 'SC',
  'Sint Maarten': 'SX',
  Slovakia: 'SK',
  Slovenia: 'SI',
  'Solomon Islands': 'SB',
  Somalia: 'SO',
  'South Africa': 'ZA',
  'South Georgia And The South Sandwich Islands': 'GS',
  Spain: 'ES',
  'Sri Lanka': 'LK',
  Sudan: 'SD',
  Suriname: 'SR',
  'Svalbard And Jan Mayen': 'SJ',
  Sweden: 'SE',
  Switzerland: 'CH',
  Syria: 'SY',
  Tajikistan: 'TJ',
  'Tanzania, United Republic Of': 'TZ',
  Thailand: 'TH',
  Timor: 'TL',
  Togo: 'TG',
  Tokelau: 'TK',
  Tonga: 'TO',
  'Trinidad and Tobago': 'TT',
  Tunisia: 'TN',
  Turkey: 'TR',
  Turkmenistan: 'TM',
  'Turks And Caicos Islands': 'TC',
  Tuvalu: 'TV',
  Uganda: 'UG',
  'United Arab Emirates': 'AE',
  Uruguay: 'UY',
  Uzbekistan: 'UZ',
  Venezuela: 'VE',
  Vanuatu: 'VU',
  'Vatican City State': 'VA',
  Vietnam: 'VN',
  'Virgin Islands, British': 'VG',
  'Wallis And Futuna': 'WF',
  'Western Sahara': 'EH',
  Yemen: 'YE',
  Zambia: 'ZM',
}
